import React, { useState, useEffect, useCallback } from 'react';
import { Button, FormControlLabel, Checkbox, Typography, Switch } from '@mui/material';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Grid from '@mui/material/Grid2';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import CheckIcon from '@mui/icons-material/Check';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useSelector, useDispatch } from 'react-redux';
import { createAvailability, filterOcplcKmat, GetProductLine, modelAvailability, getOcplcChoices, GetDefaultFeatureDropDown, GetDefaultFeatureValueDropDown, productGroupDropDown, GetParameters, GetParametersDropdown, GetLocChoiceName, GetLocChoiceValue, GetParametersLocDropdown } from 'actions/ocplcAction';
import { MATERIAL_AVAILABILITY, PRODUCT_FAMILY_PATTERN, REGIONS, REQUIRED_FIELDS, FACTORY_SERVICES, MODEL_AVAILABILITY_TABLE, DEFAULT_LOC, REQUIRED_FIELDS_DEFAULT_LOC, TOF_PROGRAM_MANAGEMENT, REQUIRED_FIELDS_FOR_TOF_PROGRAM, REQUIRED_FIELDS_MATERIAL, LOC_CHOICE_ID, LOC_MAPPING, COMPLETE_WARNING_MESSAGE, DUMMY_DATE } from 'constants/ocplcConstants';
import dayjs from 'dayjs';
import { useStyles } from 'pages/ocplcDashboard/ocplcHelpers';

const initialFormData = (version, region, productGroup, defaultproductLine, userEmail, isTOFPM, isLocChoiceId, isDefaultLocalization) => ({
  VERSION: version || '0002',
  REGION: region || '',
  PRODUCT_LINE: defaultproductLine?.name || '',
  PRODUCT_FAMILY: isDefaultLocalization || isTOFPM || isLocChoiceId ? 'ALL' : '',
  PRODUCT_DESC: isDefaultLocalization ? 'ALL' : '',
  COUNTRY: 'ALL',
  COUNTRY_DESCRIPTION: 'ALL',
  BUSINESS_MODEL: 'ALL',
  PRODUCT_GROUP: productGroup || '',
  START_DATE: null,
  END_DATE: null,
  START_DATE: null,
  END_DATE: null,
  COMMENT: '',
  apRegion: true,
  euRegion: true,
  naRegion: true,
  laRegion: true,
  MATERIAL: '',
  CHOICE_ID: '',
  LOCALIZATION: 'ALL',
  REGIONAL_LOCK: true,
  LOC_FEATURE: '',
  LOC_FEATURE_VALUE: '',
  PARAMETER: '',
  PARAMETER_NAME: '',
  PARAMETER_VALUE: '',
  whoChanged: userEmail
});

const AddDialog = ({ open, onClose, version, region, productGroup, productLineID, userEmail, kmatId, filterKmats, businessModels, setCheckedRows, selectedTable, categories, checkedRow, countryList, filterOcplcKmatForPG, selectedCategory, regionDropdown, setSelectedIds, getFormData, getConfirmationDialog }) => {
  const isMaterialAvailability = selectedTable === MATERIAL_AVAILABILITY;
  const isServiceAvailabilty = selectedTable === FACTORY_SERVICES;
  const isModelAvailabilty = selectedTable === MODEL_AVAILABILITY_TABLE;
  const isDefaultLocalization = selectedTable === DEFAULT_LOC;
  const isTOFPM = selectedTable === TOF_PROGRAM_MANAGEMENT;
  const isLocChoiceId = selectedTable === LOC_CHOICE_ID;
  const isLocMapping = selectedTable === LOC_MAPPING;
  const defaultFeatureDropdown = useSelector((state) => state.ocplc?.defaultFeatureDropdown);
  const productGroupDropdown = useSelector((state) => state.ocplc?.productGroupDropdown);
  const defaultFeatureValueDropdown = useSelector((state) => state.ocplc?.defaultFeatureValueDropdown);
  const localizationChoice = useSelector((state) => state.ocplc?.localizationChoice);
  const localizationChoiceValue = useSelector((state) => state.ocplc?.localizationChoiceValue);
  const parametersDropdown = useSelector((state) => state.ocplc?.parametersDropdown);
  const localizationMapping = useSelector((state) => state.ocplc?.localizationMapping);
  const [isMaterialError, setMaterialError] = useState('');
  const [isLocalizationError, setLocalizationError] = useState('');
  const dispatch = useDispatch();
  const classes = useStyles();
  const productLine = useSelector(state => state.ocplc.productLine) || [];
  const ocplcChoice = useSelector(state => state.ocplc.ocplcChoice) || [];
  const defaultproductLine = productLine?.find((item) => item.id === productLineID) || '';
  const defaultCategory = categories?.[0] || '';
  const [formData, setFormData] = useState({});
  const [productGroupForParameter, setProductGroupForParameter] = useState('');
  const [productFamilyError, setProductFamilyError] = useState('');

useEffect(() => {
  if (open) {
    let initialData = initialFormData(
      version,
      region,
      productGroup,
      defaultproductLine,
      userEmail,
      isTOFPM,
      isLocChoiceId,
      isLocMapping,
      isDefaultLocalization,
    );


    if ((isMaterialAvailability || isServiceAvailabilty) && kmatId) {
      initialData.PRODUCT_FAMILY = kmatId;
    }
    setFormData(initialData);

    if (isDefaultLocalization) {
      dispatch(GetDefaultFeatureDropDown());
      dispatch(GetDefaultFeatureValueDropDown());
    } else if (isTOFPM || isLocChoiceId || isLocMapping) {
      dispatch(productGroupDropDown());
    } else {
      dispatch(GetProductLine(productGroup));
    }
    if (isLocChoiceId) {
      dispatch(GetParametersDropdown());
    }
    if(isLocMapping){
      dispatch(GetParametersLocDropdown());
    } 
  
    dispatch(getOcplcChoices(isServiceAvailabilty ? '' : selectedCategory, initialData.PRODUCT_FAMILY));
  }
}, [open, defaultproductLine?.name, defaultCategory?.text, isMaterialAvailability, checkedRow]);

const isDummyDate = (date) =>
        date && dayjs(date).format().startsWith(DUMMY_DATE);
  const handleChange = async (field, value) => {
    let updatedData = { ...formData, [field]: value };

    if (field === "PRODUCT_FAMILY") {
      setProductFamilyError("");
      dispatch(getOcplcChoices(
        isServiceAvailabilty ? '' : selectedCategory,
        value
      ));
    }
    if (field === "PRODUCT_GROUP" && isTOFPM) {
      setProductGroupForParameter(value);
      dispatch(GetParameters(region, value, 'ALL'));
      formData.PARAMETER = '';
    }
    if (field === "PRODUCT_GROUP" && isLocChoiceId) {
      setProductGroupForParameter(value);
    }
    if (field === "PARAMETER" && isLocChoiceId) {
      const res = await dispatch(GetLocChoiceName(value, productGroupForParameter));
      dispatch(GetLocChoiceValue(value, productGroupForParameter));
      formData.PARAMETER_NAME = res[0]?.value || '';
      formData.PARAMETER_VALUE = '';
    }
    if (field === "START_DATE" || field === "END_DATE") {
      if (isDummyDate(value)) {
        updatedData = { ...formData, START_DATE: dayjs(DUMMY_DATE), END_DATE: dayjs(DUMMY_DATE) };
        setFormData(updatedData);
        return;
      }
    }

    // When country changes, update country description
    if (field === "COUNTRY") {
      const selectedCountry = countryList.find(
        (item) => item.countryCode === value
      );
      updatedData.COUNTRY_DESCRIPTION = selectedCountry?.countryName || "";
    }
    if (field === "PRODUCT_FAMILY" && isDefaultLocalization) {
      const selectedKmat = filterOcplcKmatForPG?.find((item) => item.kmatId === value);
      updatedData.PRODUCT_DESC = selectedKmat?.kmatDesc || '';
    }
    setFormData(updatedData);
  };

  const handleBlur = (label) => {
    if (label === "PRODUCT_FAMILY") {
      setFormData((prevFormData) => ({ ...prevFormData, PRODUCT_FAMILY: prevFormData.PRODUCT_FAMILY.toUpperCase() }));
    }
    if (label === "PARAMETER_VALUE") {
      setFormData((prev) => ({
        ...prev,
        PARAMETER_VALUE: prev.PARAMETER_VALUE
          ? prev.PARAMETER_VALUE.replace(/[^A-Za-z0-9]/g, "")
          : "",
      }));
    }
    if( label === "MATERIAL") {
      setFormData((prev) => ({
        ...prev,
        MATERIAL: prev.MATERIAL
          ? prev.MATERIAL.toUpperCase().replace(/[^A-Za-z0-9]/g, "")
          : "",
      }));
    }
    if( label === "LOCALIZATION") {
      setFormData((prev) => ({
        ...prev,
        LOCALIZATION: prev.LOCALIZATION
          ? prev.LOCALIZATION.replace(/[^A-Za-z0-9]/g, "")
          : "",
      }));
    }
  };

  const handleAddClick = () => {
    setMaterialError('');
    setLocalizationError('');
    if ((isMaterialAvailability || isServiceAvailabilty) && formData.MATERIAL && formData.MATERIAL.length > 20) {
      setMaterialError('Material cannot be more than 20 characters.');
      return;
    }
    if (isMaterialAvailability && formData?.LOCALIZATION && formData?.LOCALIZATION.length !== 3) {
      setLocalizationError('Localization code must be 3 characters - alpha numeric.');
      return;
    }
    
    if (isModelAvailabilty && !PRODUCT_FAMILY_PATTERN.test(formData.PRODUCT_FAMILY)) {
      setProductFamilyError('Product Family must be 6 alphanumeric characters followed by -999');
      return;
    }
    if(isMaterialAvailability && formData.REGIONAL_LOCK){
      getFormData(formData)
      getConfirmationDialog({open: true, message: COMPLETE_WARNING_MESSAGE, onConfirm: () => {
        dispatch(createAvailability(formData, defaultproductLine?.id, productLineID, onClose, setCheckedRows, isModelAvailabilty, isMaterialAvailability, isServiceAvailabilty, isDefaultLocalization, isTOFPM, isLocChoiceId, isLocMapping, kmatId, setSelectedIds,selectedCategory));
      }})
    }else{
        dispatch(createAvailability(formData, defaultproductLine?.id, productLineID, onClose, setCheckedRows, isModelAvailabilty, isMaterialAvailability, isServiceAvailabilty, isDefaultLocalization, isTOFPM, isLocChoiceId, isLocMapping, kmatId, setSelectedIds));
    }
  };

  const formFields = [
    ...(isDefaultLocalization || isServiceAvailabilty ? [] : [{ label: "PRODUCT_GROUP", editable: isTOFPM || isLocChoiceId || isLocMapping, type : isTOFPM || isLocChoiceId || isLocMapping ? "select" : "text" }]),
    { label: "VERSION", editable: false },
    { label: "REGION", editable: false },
    ...(isDefaultLocalization ? [{ label: "COUNTRY", editable: true, type: "select" },
    { label: "COUNTRY_DESCRIPTION", editable: false }
    ] : []),
    ...(isDefaultLocalization || isTOFPM || isLocChoiceId || isLocMapping ? [] : [{ label: "PRODUCT_LINE", editable: false }]),
    {
      label: "PRODUCT_FAMILY",
      editable: !(isTOFPM || isLocChoiceId || isLocMapping),
      type: isModelAvailabilty || isTOFPM  || isLocChoiceId || isLocMapping ? "text" : "select"
    },
    ...(isModelAvailabilty || isDefaultLocalization ? [{ label: "PRODUCT_DESC", editable: !isDefaultLocalization }] : []),
    ...(isServiceAvailabilty || isDefaultLocalization || isTOFPM  || isLocChoiceId || isLocMapping ? [] : [
      { label: "BUSINESS_MODEL", editable: !isModelAvailabilty, type: isModelAvailabilty ? "text" : "select" },
      { label: "START_DATE", editable: true, type: "date" },
      { label: "END_DATE", editable: true, type: "date" },
    ]),
    ...(!isDefaultLocalization && !isTOFPM && !isLocChoiceId && !isLocMapping ? [{ label: "REGIONS", editable: true, type: "checkbox" }] : []),
    ...(isMaterialAvailability ? [
      { label: "MATERIAL", editable: true },
      { label: "CHOICE_ID", editable: false, type: "select" },
      { label: "LOCALIZATION", editable: true },
      { label: "REGIONAL_LOCK", editable: true, type: "checkbox" },
    ] : []),
    ...(isServiceAvailabilty ? [
      { label: "MATERIAL", editable: true },
      { label: "CHOICE_ID", editable: true, type: "select" },
      { label: "LOCALIZATION", editable: false },
      { label: "START_DATE", editable: true, type: "date" },
      { label: "END_DATE", editable: true, type: "date" },
    ] : []),
    ...(isDefaultLocalization ? [
      { label: "LOC_FEATURE", editable: true, type: "select" },
      { label: "LOC_FEATURE_VALUE", editable: true, type: "select" },
    ] : []),
    ...(isTOFPM  || isLocChoiceId || isLocMapping ? [
      { label: "PARAMETER", editable: true, type: "select" },
      { label: "PARAMETER_NAME", editable: true },
      { label: "PARAMETER_VALUE", editable: true ,type:isLocChoiceId ? "select" : "text" },
    ] : []),
    { label: "COMMENT", editable: true, },
  ];

  const isFormValid = () => {
    // Dynamically filter REQUIRED_FIELDS based on isMaterialAvailability
    const fieldsToValidate = isMaterialAvailability
      ? REQUIRED_FIELDS_MATERIAL
      : isServiceAvailabilty
        ? REQUIRED_FIELDS_MATERIAL.filter(field => field !== 'BUSINESS_MODEL')
        : isDefaultLocalization
          ? REQUIRED_FIELDS_DEFAULT_LOC
          : isTOFPM || isLocChoiceId || isLocMapping
            ? REQUIRED_FIELDS_FOR_TOF_PROGRAM
            : REQUIRED_FIELDS;

    // Check if all required fields are filled
    const areRequiredFieldsFilled = fieldsToValidate.every(field => formData[field]);

    // Validate START_DATE and END_DATE
    const isStartDateValid = !(isServiceAvailabilty || isDefaultLocalization || isTOFPM || isLocChoiceId || isLocMapping) ? (formData.START_DATE && dayjs(formData.START_DATE).isValid()) : true;
    const isEndDateValid = !(isServiceAvailabilty || isDefaultLocalization || isTOFPM || isLocChoiceId || isLocMapping) ? (formData.END_DATE && dayjs(formData.END_DATE).isValid()) : true;

    const isRegStartDateValid = isServiceAvailabilty ? (formData.START_DATE && dayjs(formData.START_DATE).isValid()) : true;
    const isRegEndDateValid = isServiceAvailabilty ? (formData.END_DATE && dayjs(formData.END_DATE).isValid()) : true;

    const areDatesValid = isStartDateValid && isEndDateValid && isRegStartDateValid && isRegEndDateValid;

    const hasOnlySpaces = Object.values(formData).some(
      val => typeof val === "string" && val.trim() === "" && val.length > 0
    );

    return areRequiredFieldsFilled && areDatesValid && !hasOnlySpaces;
  };

  const renderField = (field) => {
    const { label, editable, type } = field;
    const commonProps = {
      container: true,
      alignItems: "center",
    };


    if (type === "date") {
      return (
        <Grid key={label} {...commonProps}>
          <Grid size={4}><Typography>{label}</Typography></Grid>
          <Grid size={8}>
            <DatePicker
              value={dayjs(formData[label])}
              onChange={(value) => handleChange(label, value)}
              slotProps={{ textField: { error: false } }}
              inputVariant="outlined"
              format='DD/MM/YYYY'
              renderInput={(params) => <TextField {...params} />}
            />
          </Grid>
        </Grid>
      );
    }

    if (type === "select") {
      const options = label === "BUSINESS_MODEL" ? businessModels
        : label === "CHOICE_ID" ? ocplcChoice
          : label === "PRODUCT_FAMILY" ? (isDefaultLocalization ? Object.values(filterOcplcKmatForPG ?? {}) : Object.keys(filterKmats ?? {}))
            : label === "LOC_FEATURE" ? Object.values(defaultFeatureDropdown ?? {})
              : label === "LOC_FEATURE_VALUE" ? Object.values(defaultFeatureValueDropdown ?? {})
                : label === "COUNTRY" ? countryList
                  : label === "REGION" ? Object.values(regionDropdown ? regionDropdown : {})
                    : label === "PRODUCT_GROUP" ? Object.values(productGroupDropdown ? productGroupDropdown : {})
                      : label === "PARAMETER" ? isLocChoiceId ? Object.values(localizationChoice ?? []) : isLocMapping ? Object.values(localizationMapping ?? []) : Object.values(parametersDropdown ?? [])
                        : label === "PARAMETER_VALUE" ? isLocChoiceId ? Object.values(localizationChoiceValue ?? []) : []
                        : [];
      return (
        <Grid key={label} {...commonProps}>
          <Grid size={4}><Typography>{label}</Typography></Grid>
          <Grid size={8}>
            <FormControl fullWidth>
              <Select
                value={formData[label] || ""}
                onChange={(e) => handleChange(label, e.target.value)}
                variant="outlined"
                renderValue={(selected) => selected}
              >
                {options.map((item) => {
                  if (item === "ALL" && selectedTable === FACTORY_SERVICES) return null;
                  if (item.code === "WW" && label === "REGION") return null;
                  if ((item.productGroup === "CNB" || item.productGroup === "CDT")  && label === "PRODUCT_GROUP") return null;
                  // For countryList, item is an object
                  const value = item.kmatId || item.countryCode || item.value || item.code || item.productGroup || item;
                  return (
                    <MenuItem key={value} value={value}>
                      {value}
                      {(label === "BUSINESS_MODEL") && item.text ? `  | ${item.text}` : ""}
                      {formData[label] === value && (
                        <CheckIcon className={classes.checkIcon} />
                      )}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      );
    }

    if (type === "checkbox") {
      if (label === "REGIONAL_LOCK") {
        return (
          <Grid key={label} {...commonProps}>
            <Grid size={4}><Typography>{label}</Typography></Grid>
            <Grid size={8}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formData.REGIONAL_LOCK || false}
                    onChange={(e) => handleChange("REGIONAL_LOCK", e.target.checked)}
                    disabled={formData.CHOICE_ID.startsWith("NOCHOICE")}
                  />
                }
              />
            </Grid>
          </Grid>
        );
      }

      return (
        <Grid key={label} {...commonProps}>
          <Grid size={4}><Typography>{label}</Typography></Grid>
          <Grid size={8} container spacing={3}>
            {REGIONS.map((region) => (
              <Grid key={region}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={formData[`${region.toLowerCase()}Region`] || false}
                      onChange={(e) =>
                        handleChange(`${region.toLowerCase()}Region`, e.target.checked)
                      }
                    />
                  }
                  label={region}
                />
              </Grid>
            ))}
          </Grid>
        </Grid>
      );
    }



    return (
      <Grid key={label} {...commonProps}>
        <Grid size={4}><Typography>{label}</Typography></Grid>
        <Grid size={8}>
          <TextField
            value={formData[label]}
            onChange={(e) => handleChange(label, e.target.value)}
            variant="outlined"
            fullWidth
            slotProps={{ input: { readOnly: !editable, placeholder: label } }}
            sx={{ backgroundColor: !editable ? '#f0f0f0' : 'inherit' }}
            onBlur={() => handleBlur(label)}
            disabled={!editable}
            error={label === 'PRODUCT_FAMILY' && !!productFamilyError}
            helperText={label === 'PRODUCT_FAMILY' && productFamilyError}
          />
        </Grid>
      </Grid>
    );
  };


  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Dialog
        open={open}
        onClose={onClose}
        PaperProps={{
          sx: {
            borderRadius: 2,
          }
        }}
      >
        <DialogTitle sx={{ padding: "10px" }}>
          {isModelAvailabilty ? "Add new KMAT" : isMaterialAvailability ? "Add new Material" : isDefaultLocalization ? "Add new Default Localization" : isTOFPM ? "Add TOF Program" : isLocChoiceId ? "Add Localization Choice ID" : isLocMapping ? "Add Localization" : "Add new Service"}
        </DialogTitle>
        <DialogContent sx={{ padding: "20px 10px" }}>
          <Grid container spacing={2}>
            {Object.keys(formData).length > 0 && formFields.map((field) => (
              <Grid size={12} key={field.label}>
                {renderField(field)}
              </Grid>
            ))}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Grid size={12} container direction="column" margin={2}>
            {isMaterialError && (
              <Typography color="error" sx={{ mb: 1 }}>
                {isMaterialError}
              </Typography>
            )}
            {isLocalizationError && (
              <Typography color="error" sx={{ mb: 1 }}>
                {isLocalizationError}
              </Typography>
            )}
            <Grid container justifyContent="flex-end">
              <Button variant="outlined" color="primary" onClick={onClose}>Cancel</Button>
              <Button variant="contained" color="primary" sx={{ marginLeft: 1 }} onClick={handleAddClick} disabled={!isFormValid()}>
                Add
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    </LocalizationProvider>
  );
};

export default AddDialog;